// Offline bill queue — net na ho to bill localStorage me, net aate hi sync
const KEY = "it_offline_bills_v1";

export function queueGet() {
  try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch { return []; }
}
function queueSet(list) {
  try { localStorage.setItem(KEY, JSON.stringify(list)); } catch {}
  window.dispatchEvent(new CustomEvent("it-offline-change", { detail: list.length }));
}
export function queueAdd(body) {
  const list = queueGet();
  list.push({ tmp_id: `off-${Date.now()}-${Math.random().toString(36).slice(2, 6)}`, at: new Date().toISOString(), body });
  queueSet(list);
  return list.length;
}
export function queueCount() { return queueGet().length; }
export function queueClear() { queueSet([]); }

export function isOfflineError(err) {
  return !err?.response || err.code === "ERR_NETWORK" || err.message === "Network Error";
}

export async function queueSync(api) {
  const list = queueGet();
  if (!list.length) return { synced: 0, failed: 0 };
  let synced = 0, failed = 0;
  const left = [];
  for (const item of list) {
    try {
      await api.post("/invoices", item.body);
      synced += 1;
    } catch (e) {
      if (isOfflineError(e)) { left.push(item); }
      else { failed += 1; }  // server ne reject kiya -> dobara try nahi
    }
  }
  queueSet(left);
  return { synced, failed, pending: left.length };
}
